import type { AnyRouter } from "@tanstack/react-router";

/*
 * Where "back" goes from your card and its settings. /me and /me/settings
 * link to each other, so a plain history.back() bounces between them. We
 * remember the last page outside them (your card's back goes there) and the
 * page before this one (Settings steps back to your card if it came from it).
 */
const OUTSIDE = "pm_back_outside";
let previous: string | null = null;

const isCardPage = (path: string) => path === "/me" || path.startsWith("/me/") || path === "/welcome";

export function trackReturns(router: AnyRouter) {
  router.subscribe("onResolved", ({ fromLocation, toLocation }) => {
    previous = fromLocation?.pathname ?? null;
    if (fromLocation && !isCardPage(fromLocation.pathname) && isCardPage(toLocation.pathname)) {
      try { sessionStorage.setItem(OUTSIDE, fromLocation.href); } catch { /* private mode */ }
    }
  });
}

/** The page you were on before opening your card; all clubs if unknown. */
export function outsideHref(): string {
  try { return sessionStorage.getItem(OUTSIDE) ?? "/clubs?all=true"; } catch { return "/clubs?all=true"; }
}

export const cameFrom = (path: string) => previous === path;

/**
 * Where to go after signing in. Only a path on this site: "//evil.example",
 * "/\evil.example" and full URLs fall back to your clubs, and so does a way
 * back to the sign-in or welcome pages themselves.
 */
export function safeNext(next: string | null | undefined, fallback = "/clubs"): string {
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return fallback;
  if (/^\/(signin|welcome)(?:[/?#]|$)/.test(next)) return fallback;
  return next;
}

/*
 * A hint, kept in this browser, that the last check found a session. The
 * home and sign-in pages are plain HTML that paint before any API call, so
 * an inline script reads this to send signed-in people on to their clubs
 * before the pitch flashes up. Every real session check rewrites it.
 */
const SIGNED_IN = "pm_signed_in";
export function rememberSignedIn(yes: boolean) {
  try { if (yes) localStorage.setItem(SIGNED_IN, "1"); else localStorage.removeItem(SIGNED_IN); } catch { /* private mode */ }
}
